import { forwardRef, useCallback, useEffect, useState } from "react";
import FormContainer from "../../../../../../common/components/form_container";
import { ProjetoForm } from "../../../schemas/Projetos_cadastro/Projetos_cadastro";
import { UseFormReturn } from "react-hook-form";
import { Box, FormLabel } from "@mui/material";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { DropDownCentroCusto } from "../../../../../../common/components/dropdown_centro_custo";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { FormPhoneMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_phone_masked_input";
import { ProjetoLista } from "../../../../domain/models/projetos_Lista";
import { DefaultCheckBox } from "../../../../../../common/components/default_checkbox";

type Props = {
  saving: boolean;
  selectedProjeto: ProjetoLista | undefined,
  hookForm: UseFormReturn<ProjetoForm>,
  onSubmit: (form: ProjetoForm) => void;
};

export const TabInformacoesGeraisContent = forwardRef<HTMLButtonElement, Props>(
  ({ saving, onSubmit, hookForm, selectedProjeto, }, ref) => {

    const [desativarDataInicio, setDesativarDataInicio] = useState(false);
    const [desativarDataTermino, setDesativarDataTermino] = useState(false);
    const [desativarDataInicioReal, setDesativarDataInicioReal] = useState(false);
    const [desativarDataTerminoReal, setDesativarDataTerminoReal] = useState(false);

    useEffect(() => {
      if (selectedProjeto) {
        hookForm.reset({
          idProjeto: selectedProjeto.IdProjeto,
          descricaoProjeto: selectedProjeto.DescricaoProjeto ?? "",
          numeroContrato: selectedProjeto.NumeroContrato,
          idCentroCusto: selectedProjeto.IdCentroCusto,

          dataInicio: selectedProjeto.DataInicio,
          dataTermino: selectedProjeto.DataTermino,
          dataInicioreal: selectedProjeto.DataInicioReal,
          dataTerminoreal: selectedProjeto.DataTerminoReal,

          contato1: selectedProjeto.Contato1,
          telefone1: selectedProjeto.Telefone1,
          email1: selectedProjeto.Email1,

          contato2: selectedProjeto.Contato2,
          telefone2: selectedProjeto.Telefone2,
          email2: selectedProjeto.Email2,

          escopo: selectedProjeto.Escopo,
          dadosEntrada: selectedProjeto.DadosEntrada,
        });

        setDesativarDataInicio(selectedProjeto.DataInicio == null);
        setDesativarDataTermino(selectedProjeto.DataTermino == null);
        setDesativarDataInicioReal(selectedProjeto.DataInicioReal == null);
        setDesativarDataTerminoReal(selectedProjeto.DataTerminoReal == null);
      } else {
        hookForm.reset({});

        setDesativarDataInicio(false);
        setDesativarDataTermino(false);
        setDesativarDataInicioReal(false);
        setDesativarDataTerminoReal(false);
      }
    }, [hookForm, selectedProjeto]);

    const handleSubmit = useCallback(
      (form: ProjetoForm) => {
        if (!saving) onSubmit(form);
      },
      [saving, onSubmit],
    );


    return (
      <>
        {/* Descrição + Nº Contrato */}
        <form onSubmit={hookForm.handleSubmit(handleSubmit)}>
          <div className="w-full flex flex-col gap-8 bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer title={"Projeto"} arrangement="fullRow">
              <>
                <DefaultFormInput label="Descrição" name="descricaoProjeto" reactHookForm={hookForm} required={true} />
                <DefaultFormInput label="Nº do Contrato" name="numeroContrato" reactHookForm={hookForm} />
                {/* Centro de Custo */}
                <DropDownCentroCusto name="idCentroCusto" required={false} readOnly={saving} reactHookForm={hookForm} />
                {/* Datas Previstas */}

                <Box display="flex" flexDirection="row" gap={4} justifyContent={"space-around"}>
                  {/* Coluna: Datas Previstas */}
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" alignItems="center" gap={2}>
                      <FormDatePickerInput
                        name="dataInicio"
                        label="Início Previsto"
                        reactHookForm={hookForm}
                        required={false}
                        disabled={desativarDataInicio}
                      />
                      <DefaultCheckBox
                        name="desativarDataInicio"
                        label="NA"
                        disabled={saving}
                        value={desativarDataInicio}
                        onChangeValue={(marcado) => {
                          setDesativarDataInicio(marcado);
                          if (marcado) {
                            hookForm.setValue("dataInicio", null);
                          }
                        }}
                      />
                    </Box>

                    <Box display="flex" alignItems="center" gap={2}>
                      <FormDatePickerInput
                        name="dataTermino"
                        label="Término Previsto"
                        reactHookForm={hookForm}
                        required={false}
                        disabled={desativarDataTermino}
                      />
                      <DefaultCheckBox
                        name="desativarDataInicio"
                        label="NA"
                        disabled={saving}
                        value={desativarDataTermino}
                        onChangeValue={(marcado) => {
                          setDesativarDataTermino(marcado);
                          if (marcado) {
                            hookForm.setValue("dataTermino", null);
                          }
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Coluna: Datas Reais */}
                  <Box display="flex" flexDirection="column" gap={2}>
                    <Box display="flex" alignItems="center" gap={2}>
                      <FormDatePickerInput
                        name="dataInicioreal"
                        label="Início Real"
                        reactHookForm={hookForm}
                        required={false}
                        disabled={desativarDataInicioReal}
                      />
                      <DefaultCheckBox
                        name="desativarDataInicio"
                        label="NA"
                        disabled={saving}
                        value={desativarDataInicioReal}
                        onChangeValue={(marcado) => {
                          setDesativarDataInicioReal(marcado);
                          if (marcado) {
                            hookForm.setValue("dataInicioreal", null);
                          }
                        }}
                      />
                    </Box>

                    <Box display="flex" alignItems="center" gap={2}>
                      <FormDatePickerInput
                        name="dataTerminoreal"
                        label="Término Real"
                        reactHookForm={hookForm}
                        required={false}
                        disabled={desativarDataTerminoReal}
                      />
                      <DefaultCheckBox
                        name="desativarDataInicio"
                        label="NA"
                        disabled={saving}
                        value={desativarDataTerminoReal}
                        onChangeValue={(marcado) => {
                          setDesativarDataTerminoReal(marcado);
                          if (marcado) {
                            hookForm.setValue("dataTerminoreal", null);
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            </FormContainer>
            {/* Contatos */}
            <FormContainer title={"Contato 1"} arrangement="fullRow">
              <>
                <DefaultFormInput name="contato1" label="Contato" reactHookForm={hookForm} />

                <FormPhoneMaskedInput name="telefone1" type="movel" label="Telefone" reactHookForm={hookForm} />

                <DefaultFormInput name="email1" label="Email" reactHookForm={hookForm} />
              </>
            </FormContainer>
            <FormContainer title={"Contato 2"} arrangement="fullRow">
              <>
                <DefaultFormInput name="contato2" label="Contato" reactHookForm={hookForm} />

                <FormPhoneMaskedInput name="telefone2" type="movel" label="Telefone" reactHookForm={hookForm} />

                <DefaultFormInput name="email2" label="Email" reactHookForm={hookForm} />
              </>
            </FormContainer>
            {/* Escopo */}
            <FormLabel>Escopo</FormLabel>
            <DefaultFormInput name="escopo" label="" multiline rows={6} readOnly={saving} reactHookForm={hookForm} />
            {/* Dados de Entrada */}
            <FormLabel>Dados de Entrada</FormLabel>
            <DefaultFormInput name="dadosEntrada" label="" multiline rows={6} readOnly={saving} reactHookForm={hookForm} />

          </div>
        </form>
      </>
    );
  },
);
